/**
 * `/workforce` — le persone dell'organizzazione, in due facce che restano due.
 *
 * La **dashboard HR** (default) risponde a «come sta andando»: quanti sono, dove lavorano
 * oggi, cosa manca. L'**elenco** (`?view=table`) risponde a «trovami questa persona», con i
 * filtri e le colonne che servono a riconoscerla. Sul telefono c'è la schermata dedicata, che
 * non è né l'una né l'altra.
 *
 * Le due viste non si somigliano di proposito: unirle darebbe una tabella con dei grafici
 * sopra, cioè una pagina che risponde male a entrambe le domande.
 */
import { createFileRoute } from '@tanstack/react-router';
import { DesktopHR } from '@/features/workforce/desktop/DesktopHR';
import { EmployeesListPage } from '@/features/workforce/EmployeesListPage';
import { MobileWorkforce } from '@/features/workforce/mobile/MobileWorkforce';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';

export const Route = createFileRoute('/_app/workforce/')({
  validateSearch: (s: Record<string, unknown>): { view?: 'table' } => ({ view: s.view === 'table' ? 'table' : undefined }),
  component: WorkforcePage,
});

function WorkforcePage() {
  const { view } = Route.useSearch();
  const isMobile = useIsMobileShell();
  if (isMobile && view !== 'table') return <MobileWorkforce />;
  return view === 'table' ? <EmployeesListPage /> : <DesktopHR />;
}
